/** Statuts métier partagés. */
export type ModerationStatus = 'pending' | 'approved' | 'rejected';
export type OfferStatus = 'pending' | 'active' | 'rejected' | 'suspended';
export type PublicationStatus = 'draft' | 'published';
export type AccountStatus = 'active' | 'disabled';

export type AdminRole = 'SUPER_ADMIN' | 'ADMIN' | 'EDITOR' | 'VIEWER';

/** Section du back-office soumise au RBAC. */
export type RightsScope =
  | 'companies'
  | 'offers'
  | 'articles'
  | 'addresses'
  | 'fruits'
  | 'performance'
  | 'formulas'
  | 'countries'
  | 'users'
  | 'admins';

export interface ScopeRights {
  create: boolean;
  edit: boolean;
  delete: boolean;
}

export type RightsMatrix = Record<RightsScope, ScopeRights>;

export const RIGHTS_SCOPES: readonly RightsScope[] = [
  'companies',
  'offers',
  'articles',
  'addresses',
  'fruits',
  'performance',
  'formulas',
  'countries',
  'users',
  'admins',
];

export type NotificationChannel = 'email' | 'app' | 'both';
export type NotificationType = 'offerApproved' | 'offerRejected' | 'articlePublished';

/** Contrat de pagination renvoyé par tous les repositories de liste. */
export interface Page<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
  pageCount: number;
}

export interface PageRequest {
  page: number;
  pageSize: number;
}

export const DEFAULT_PAGE_SIZE = 10;

export function emptyPage<T>(pageSize: number = DEFAULT_PAGE_SIZE): Page<T> {
  return { items: [], total: 0, page: 1, pageSize, pageCount: 1 };
}

/** Pagination applicative (utilisée par les repositories in-memory). */
export function buildPage<T>(all: readonly T[], { page, pageSize }: PageRequest): Page<T> {
  const total = all.length;
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  const safePage = Math.min(Math.max(1, page), pageCount);
  const start = (safePage - 1) * pageSize;
  return {
    items: all.slice(start, start + pageSize),
    total,
    page: safePage,
    pageSize,
    pageCount,
  };
}
